import clsx from 'clsx';
import {ReactNode} from 'react';

export type ImageItemViewProps = {
  header?: ReactNode;
  overlay?: ReactNode;
  footer?: ReactNode;
  containerProps?: React.ComponentProps<'div'>;
  //   filename?: string;
  //   onToggleChecked?: (val?: boolean) => void;
  //   checked?: boolean;
  //   checkable?: boolean;
} & React.ComponentProps<'img'>;

export const ImageItemView = (props: ImageItemViewProps) => {
  const {
    containerProps,
    className,
    header,
    overlay,
    footer,
    children,
    onClick,
    // checkable = true,
    // onToggleChecked,
    // checked,
  } = props;
  const imgProps: React.ComponentProps<'img'> = props;

  return (
    <div
      {...containerProps}
      className={clsx('group cursor-pointer relative', containerProps?.className)}
      onClick={onClick}>
      <img
        src={imgProps.src}
        alt={imgProps.alt}
        className={clsx(
          'w-full h-48 object-cover border rounded-lg transition-transform transform scale-100 group-hover:scale-105',
          className,
        )}
      />
      {header && (
        <div className="absolute top-0 left-0 w-full h-full invisible group-hover:visible overflow-hidden">
          {header}
        </div>
      )}
      {/* {checkable && (
        <div className="absolute bottom-0 right-0 p-1">
          <Checkbox checked={checked} onChange={e => onToggleChecked?.(e.target.checked)} />
        </div>
      )} */}
      {overlay && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          {overlay}
        </div>
      )}
      {footer && (
        <div className="absolute bottom-0 right-0 invisible group-hover:visible bg-white border rounded-lg p-1">
          {footer}
        </div>
      )}
      {children}
    </div>
  );
};
